import { render, staticRenderFns } from "./magazzinoTemporaneo.vue?vue&type=template&id=ba662c0a"
import script from "./magazzinoTemporaneo.vue?vue&type=script&lang=js"
export * from "./magazzinoTemporaneo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports